import React, { useState } from 'react';
import { Banknote, Calculator, CreditCard } from 'lucide-react';
import SepaPlansAdminPanel from '../SepaPlansAdminPanel';
import { EncaissementsDashboard } from './EncaissementsDashboard';
import { EcheanciersCbPanel } from './EcheanciersCbPanel';
import { ComptabiliteAdminPanel } from '../comptabilite/ComptabiliteAdminPanel';

export default function SepaCbPanel() {
  const [vue, setVue] = useState('cb');
  const tab = (k, label, Icon) => (
    <button type="button" onClick={() => setVue(k)} data-testid={`sepacb-vue-${k}`}
      className={`inline-flex items-center gap-2 px-4 py-2 rounded-xl text-sm font-semibold ${vue === k ? 'bg-[#0a3d62] text-white shadow' : 'bg-white border border-slate-200 text-slate-700 hover:bg-slate-50'}`}>
      <Icon className="h-4 w-4" /> {label}
    </button>
  );
  return (
    <div className="space-y-4" data-testid="sepa-cb-panel">
      <EncaissementsDashboard />
      <div className="flex gap-2">
        {tab('cb', 'Échéanciers CB', CreditCard)}
        {tab('sepa', 'Mandats SEPA', Banknote)}
        {tab('compta', 'Comptabilité & exports', Calculator)}
      </div>
      {vue === 'cb' ? <EcheanciersCbPanel /> : vue === 'sepa' ? <SepaPlansAdminPanel /> : <ComptabiliteAdminPanel />}
    </div>
  );
}
